import React from 'react';
import styled from 'styled-components';
import Icon from '@ant-design/icons';
import ArrowRightOutlinedIcon from '@icons/sankey/arrow-right-outlined.svg';
import { useWorkflowStore } from '@src/pages/workflow/store';

const CollapseIcon = styled(Icon)`
  cursor: pointer;
  user-select: none;

  width: 28px;
  height: 28px;
  display: block;
  padding: 6px;
  margin-left: 16px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  &:hover {
    background: #e9edf0;
  }
  transition: color ease-in 0.3s;
`;
const FoldIcon = () => {
  const { isPanelOpen, setIsPanelOpen } = useWorkflowStore();
  const handleCollapse = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsPanelOpen(!isPanelOpen);
  };

  return (
    <CollapseIcon
      rotate={isPanelOpen ? 180 : 0}
      component={ArrowRightOutlinedIcon}
      onClick={handleCollapse}
    />
  );
};

export default FoldIcon;
